import React from 'react';
import { Button } from './Button';
import { ImageClickable } from './ImageClickable';
import { Star, Users, BookOpen, Gift, MapPin } from 'lucide-react';
export function Hero() {
  const miniReviews = [{
    name: 'Julieta',
    city: 'CABA',
    img: 'https://randomuser.me/api/portraits/women/17.jpg',
    text: 'Hoy hace 3 meses que no le hablo y por primera vez siento paz.'
  }, {
    name: 'Carolina',
    city: 'Córdoba',
    img: 'https://randomuser.me/api/portraits/women/42.jpg',
    text: 'Pensé que era mentira, pero es real. Me asistieron por WhatsApp y terminé comprando sintiéndome muy segura <3'
  }, {
    name: 'Micaela',
    city: 'Rosario',
    img: 'https://randomuser.me/api/portraits/women/65.jpg',
    text: 'No es solo teoría, te da las herramientas para cortar el ciclo.'
  }];
  return <section id="compra" className="pt-6 pb-6 px-3 md:px-4 flex flex-col items-center text-center bg-gradient-to-b from-black to-dark relative overflow-hidden" data-id="element-99">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-rosa to-terracota" data-id="element-100"></div>

      <div className="bg-rosa/20 text-rosa border border-rosa/50 px-3 py-1 rounded-full text-[10px] md:text-xs font-bold uppercase tracking-widest mb-3 animate-pulse" data-id="element-101">
        Acceso Disponible Hoy
      </div>

      <h2 className="text-sm md:text-xl font-medium text-gray-300 mb-1 leading-tight" data-id="element-102">
        Para mujeres que están cansadas de{' '}
        <strong className="text-white" data-id="element-103">depender emocionalmente</strong>
      </h2>
      <h3 className="text-sm md:text-lg text-terracota font-semibold mb-4" data-id="element-104">
        Para mujeres que van a empezar a <strong data-id="element-105">elegirse</strong>
      </h3>

      <h1 className="text-3xl md:text-6xl font-black text-white mb-4 md:mb-6 leading-tight uppercase tracking-tight drop-shadow-lg" data-id="element-106">
        LA MUJER QUE{' '}
        <span className="text-transparent bg-clip-text bg-gradient-to-r from-rosa to-terracota" data-id="element-107">
          SE ELIJE
        </span>
      </h1>

      <div className="w-full max-w-md mx-auto mb-4 relative" data-id="element-108">
        <div className="absolute -inset-4 bg-rosa/20 blur-2xl rounded-full z-0" data-id="element-109"></div>
        <ImageClickable src="https://cdn.magicpatterns.com/uploads/eyqQzBSsMfB63itBUat17z/2B5_BONOS.png" alt="La Mujer que se Elige Libro Digital" className="relative z-10 w-full rounded-lg border border-white/10" data-id="element-110" />
      </div>

      <p className="text-sm md:text-lg text-gray-200 max-w-2xl mx-auto mb-3 font-medium bg-black/40 p-3 md:p-4 rounded-xl border border-white/5" data-id="element-111">
        La guia para{' '}
        <strong className="text-white" data-id="element-112">
          ponerle fin a la dependencia emocional
        </strong>
        , <strong className="text-white" data-id="element-113">romper el patrón</strong> y{' '}
        <strong className="text-white" data-id="element-114">recuperar el control de tu vida</strong>
      </p>

      <div className="flex flex-wrap justify-center gap-2 mb-6" data-id="element-115">
        <span className="bg-white/10 text-white text-xs font-bold px-3 py-1 rounded-full border border-white/20" data-id="element-116">
          Inmediato
        </span>
        <span className="bg-white/10 text-white text-xs font-bold px-3 py-1 rounded-full border border-white/20" data-id="element-117">
          PDF
        </span>
        <span className="bg-white/10 text-white text-xs font-bold px-3 py-1 rounded-full border border-white/20" data-id="element-118">
          AR 🇦🇷
        </span>
      </div>

      <Button className="mb-4" data-id="element-119">QUIERO EMPEZAR AHORA</Button>

      <div className="w-full max-w-2xl mx-auto mt-2 mb-8" data-id="element-120">
        <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 text-xs md:text-sm font-medium text-gray-300" data-id="element-121">
          <div className="flex items-center gap-1" data-id="element-122">
            <Users size={14} className="text-rosa" data-id="element-123" /> +500 mujeres que se
            eligieron
          </div>
          <div className="flex items-center gap-1" data-id="element-124">
            <BookOpen size={14} className="text-terracota" data-id="element-125" /> 5 Módulos
          </div>
          <div className="flex items-center gap-1" data-id="element-126">
            <Gift size={14} className="text-rosa" data-id="element-127" /> 5 Bonos incluidos
          </div>
          <div className="flex items-center gap-1" data-id="element-128">
            <Star size={14} className="text-yellow-500 fill-yellow-500" data-id="element-129" /> 4.9/5
          </div>
          <div className="flex items-center gap-1" data-id="element-130">
            <MapPin size={14} className="text-terracota" data-id="element-131" /> 🇦🇷 Todo el país
          </div>
        </div>
      </div>

      <div className="w-full max-w-3xl mx-auto overflow-x-auto pb-4 snap-x snap-mandatory hide-scrollbar" data-id="element-132">
        <div className="flex md:grid md:grid-cols-3 gap-3 w-max md:w-full px-4 md:px-0" data-id="element-133">
          {miniReviews.map((review, idx) => <div key={idx} className="bg-black/50 border border-white/10 rounded-xl p-3 w-64 md:w-auto flex-shrink-0 snap-center text-left flex flex-col" data-id="element-134">
              <div className="flex items-center gap-1 mb-2" data-id="element-135">
                {[...Array(5)].map((_, i) => <Star key={i} size={10} className="text-terracota fill-terracota" data-id="element-136" />)}
              </div>
              <p className="text-gray-300 text-xs italic mb-3 flex-grow" data-id="element-137">
                "{review.text}"
              </p>
              <div className="flex items-center gap-2 mt-auto" data-id="element-138">
                <img src={review.img} alt={review.name} className="w-8 h-8 rounded-full object-cover border border-rosa" data-id="element-139" />
                <div data-id="element-140">
                  <p className="text-white font-bold text-[10px]" data-id="element-141">
                    {review.name}
                  </p>
                  <p className="text-gray-500 text-[9px]" data-id="element-142">{review.city}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}